import { apiFetch } from "@/lib/api-client";

export const apiRegister = (data: { email: string; username: string; password: string }) =>
  apiFetch("/api/register", { method: "POST", body: data, skipAuthRedirect: true });

export const apiLogin = (data: { email: string; password: string }) =>
  apiFetch("/api/login", { method: "POST", body: data, skipAuthRedirect: true });

export const apiGoogleAuth = (idToken: string) =>
  apiFetch("/api/auth/google", { method: "POST", body: { idToken }, skipAuthRedirect: true });

export const apiGetMe = (token: string) => apiFetch("/api/me", { token });

export const apiClaimAdReward = (token: string): Promise<{ chips_awarded: number }> =>
  apiFetch("/api/claim-ad-reward", { method: "POST", token });
